import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import AppLoader from './components/appLoader/appLoader';
//import { HashRouter } from 'react-router-dom'

import style from './App.module.scss';
import ProtectedRoute from './components/SignUp/ProtectedRoute';


const Landing = lazy(() => import('./containers/landing/landing.container' /* webpackChunkName: "testContainer" */));
const Manual = lazy(() => import('./containers/Manual/manual.container' /* webpackChunkName: "testContainer" */));
const AppLayout = lazy(() => import('./containers/appLayout/appLayout.container' /* webpackChunkName: "testContainer" */));
//const TestComponent = lazy(() => import('./components/test/test.component' /* webpackChunkName: "test" */));
const Signup = lazy(() => import('./components/SignUp/Singup' /* webpackChunkName: "test" */));
const Login = lazy(() => import('./components/SignUp/Login' /* webpackChunkName: "test" */));
const UpdateProfile = lazy(() => import('./components/SignUp/UpdateProfile' /* webpackChunkName: "test" */));
const HomePage = lazy(() => import('./components/SignUp/HomePage' /* webpackChunkName: "test" */));
const ShowUserProfile = lazy(() => import('./components/SignUp/ShowUserProfile' /* webpackChunkName: "test" */));
const ChangePassword = lazy(() => import('./components/SignUp/ChangePassword'));
const Account = lazy(() => import('./components/SignUp/Account.js'));
const PasswordForgot = lazy(() => import('./components/SignUp/PasswordForgot' /* webpackChunkName: "test" */));


const Routes = () => (
    <>
        <Suspense fallback={<AppLoader />}>
            <header className={style.appHeader}>
                <Switch>
                    {/* <HashRouter> */}
                        <Route path="/signup" strict exact component={Signup} />
                        <Route path="/forgot-password" strict exact component={PasswordForgot} />
                       {/*  <Route path="/" exact component={TestComponent} /> */}
                        <ProtectedRoute path="/show_profile" component={ShowUserProfile} />
                        <ProtectedRoute path="/update_profile" component={Account} />
                        <ProtectedRoute path="/account/password" component={Account} />
                        <ProtectedRoute path="/account" component={Account} />
                        <ProtectedRoute path="/account/profile" component={Account} />
                        {/* <AppLayout> */}
                        <ProtectedRoute path="/manual" exact component={Manual} />
                        {/* </AppLayout> */}
                        <Route path="/" exact component={Login} />
                        <ProtectedRoute path="/home" exact component={HomePage} />
                        <AppLayout>
                            <ProtectedRoute path="/automatic" exact component={Landing} />
                        </AppLayout>
                   {/*  </HashRouter> */}
                </Switch>
            </header>
        </Suspense>
    </>
);

export default Routes;
